<style lang="scss">
.card {
    @apply bg-slate-100 #{!important};
}

.vtl-paging-pagination-page-li-number {
    @apply font-bold #{!important};
}

thead {
    position: sticky !important;
    top: 0 !important;
    z-index: 2;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
}

.card {
    @apply pt-3 #{!important};
    word-wrap: normal !important;
}

.page-link {
    padding: 0.1rem 0.4rem !important;
}

table {
    @apply border-b border-gray-200 shadow;
}

.thead-dark, tr td, body, select {
    font-family: Nunito, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    @apply text-sm #{!important};
}

.thead-dark th {
    @apply bg-sky-900 border-none border-sky-900 #{!important};
    padding: 0.5rem !important;
    line-height: 1 !important;
}

.thead-dark th:first-child {
    @apply rounded-tl-lg #{!important};
}

.thead-dark th:last-child {
    @apply rounded-tr-lg #{!important};
}

tbody tr:last-child td:first-child {
    @apply rounded-bl-lg #{!important};
}

#dataTables-example_wrapper select {
    @apply pr-7 mr-3 ml-1 pl-1
}

td, th, table, tbody, tr {
    border: none !important;
}

tr {
    @apply 2xl:hover:bg-blue-200
}

tr td {
    padding: 0.4rem 0.1rem !important;
    box-sizing: border-box !important;
    height: 0;
}

tr {
    position: relative;
}

tr td:first-child:before {
    width: 5px;
    content: ' ';
    font-size: 1px;
    border: none;
    height: 100%;
    @apply bg-slate-100 #{!important};
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}

tr td:last-child:before {
    width: 5px;
    content: ' ';
    font-size: 1px;
    border: none;
    height: 100%;
    @apply bg-slate-100 #{!important};
    display: block;
    position: absolute;
    top: 0;
    right: 0;
}

td:not(tr:last-child td) {
    border-bottom: 1px solid lightgray !important;
}

table td, table th {
    vertical-align: middle !important;
}

tr td:first-child {
    padding-left: 10px !important;
}

#dataTables-example {
    max-height: calc(100vh - 310px);
    height: calc(100vh - 360px);
    overflow: auto;
    @apply block #{!important};
}

.col-sm-12 {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
}
</style>
<template>
    <div id="loader"
         class="fixed w-full h-full left-0 top-0 flex justify-center content-center flex-wrap z-10 bg-slate-900/75"
         :class="{hidden: loaderHidden}">
        <div class="py-5 bg-white rounded-lg text-center" style="opacity: 0.8;">
            <img class="inline-block" src="/storage/img/loader.gif"/>
        </div>
    </div>
    <div :class="{hidden: image.hidden}"
         class="transition-all bg-black/50 flex justify-center items-center fixed z-20 top-2 left-2 right-2 bottom-2">
        <div class="absolute top-5 right-5 z-10"><i class="fa fa-2x fa-times cursor-pointer text-amber-400"
                                                    @click="image.hidden = true"></i></div>
        <img alt="Image of article" class="md:w-9/12 lg:w-2/3 xl:w-1/2" :src="image.src"/>
    </div>
    <div class="p-6">
        <div class="flex justify-between flex-wrap">
            <div class="w-full lg:w-4/12 pr-2">
                <form @submit.prevent="doSearch" class="flex flex-wrap justify-start items-center">
                    <label for="search_it" class="font-bold sm:text-right w-1/12 mx-3">Procurar</label>
                    <div class="inline px-2 w-7/12">
                        <input autocomplete="off" v-model="search"
                               class="w-full appearance-none my-2 bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                               id="search_it" type="text">
                    </div>
                    <button type="submit"
                            class="bg-white mr-1 hover:bg-gray-100 text-gray-800 px-4 font-semibold py-2 border border-gray-400 rounded shadow">
                        OK
                    </button>
                    <button type="button" @click="clearSearch"
                            class="bg-white hover:bg-gray-100 text-gray-800 px-4 font-semibold py-2 border border-gray-400 rounded shadow">
                        Limpar
                    </button>
                </form>
            </div>
            <div v-if="ordersTable" class="w-full py-5 sm:py-0 lg:w-4/12 flex flex-wrap">
                <p class="w-full font-bold block">Colunas</p>
                <div>
                    <label for="id" class="mr-2">Nr</label>
                    <input v-model="columns.value[0].value"
                           class="mr-5 appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           id="id" type="checkbox"/>
                </div>
                <div>
                    <label for="name" class="mr-2">Nome</label>
                    <input v-model="columns.value[1].value"
                           class="mr-5 appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           id="name" type="checkbox"/>
                </div>
                <div>
                    <label for="buyer_name" class="mr-2">Nome Comprador</label>
                    <input v-model="columns.value[2].value"
                           class="mr-5 appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           id="buyer_name" type="checkbox"/>
                </div>
                <div>
                    <label for="country" class="mr-2">País</label>
                    <input v-model="columns.value[3].value"
                           class="mr-5 appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           id="country" type="checkbox"/>
                </div>
                <div>
                    <label for="token" class="mr-2">URL</label>
                    <input v-model="columns.value[4].value"
                           class="mr-5 appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           id="token" type="checkbox"/>
                </div>
                <div>
                    <label for="articles" class="mr-2">Nr Peças</label>
                    <input v-model="columns.value[5].value"
                           class="mr-5 appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           id="articles" type="checkbox"/>
                </div>

                <div>
                    <label for="status" class="mr-2">Estado</label>
                    <input v-model="columns.value[6].value"
                           class="mr-5 appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           id="status" type="checkbox"/>
                </div>
                <div>
                    <label for="created_at" class="mr-2">Data Criação</label>
                    <input v-model="columns.value[7].value"
                           class="mr-5 appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           id="created_at" type="checkbox"/>
                </div>
                <div>
                    <label for="payment_id" class="mr-2">Pagamento</label>
                    <input v-model="columns.value[8].value"
                           class="mr-5 appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           id="payment_id" type="checkbox"/>
                </div>
                <div>
                    <label for="payment_id" class="mr-2">Total</label>
                    <input v-model="columns.value[9].value"
                           class="mr-5 appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           id="payment_id" type="checkbox"/>
                </div>
                <div>
                    <label for="payment_id" class="mr-2">Levantamento</label>
                    <input v-model="columns.value[10].value"
                           class="mr-5 appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           id="payment_id" type="checkbox"/>
                </div>
            </div>
            <div v-if="ordersTable" class="w-full lg:w-1/12 text-center pr-5">
                <label for="only-not-ready" class="mr-2 font-bold block">C/ artigos em falta</label>
                <input v-model="onlyMissingArticles.value"
                       class="appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                       id="only-not-ready" type="checkbox"/>
            </div>
            <div v-if="ordersTable" class="w-full lg:w-1/12 text-center pr-5">
                <label for="only-not-ready" class="mr-2 font-bold block">Levantamento em loja</label>
                <input v-model="onlyStorePickup.value"
                       class="appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                       id="only-not-ready" type="checkbox"/>
            </div>
            <div v-if="articlesTable" class="w-full lg:w-1/12 text-center pr-5">
                <label for="only-paid" class="mr-2 font-bold block">Pagos em falta</label>
                <input v-model="onlyPaidArticles.value"
                       class="appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                       id="only-paid" type="checkbox"/>
            </div>
            <div v-if="ordersTable" class="w-full lg:w-2/12">
                <label for="grid_state" class="font-bold">Estado</label>
                <select id="grid_state" @change="this.$emit('changeStatus', $event)" v-model="status_list"
                        class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                >
                    <option :value="'1,2,3,4,5'">Todos (não apagados)</option>
                    <option v-for="status in statuses" :value="status.id">{{ status.name }}</option>
                </select>
            </div>
        </div>
        <table-lite
            :key="myKey"
            :is-slot-mode="true"
            :has-checkbox="table.has_checkbox"
            :is-loading="table.isLoading"
            :is-re-search="table.isReSearch"
            :columns="table.columns"
            :rows="table.rows"
            :total="table.totalRecordCount"
            :sortable="table.sortable"
            :messages="table.messages"
            :page="page.value"
            @edit="edit"
            @do-search="doSearch"
            @is-finished="tableLoadingFinish"
            @return-checked-rows="updateCheckedRows"
        >
            <template v-slot:id="data">
                {{ data.value.id }}
            </template>
            <template v-slot:name="data">
                {{ data.value.name }}
            </template>
            <template v-slot:buyer_name="data">
                {{ data.value.buyer_name }}
            </template>
            <template v-slot:country="data">
                {{ data.value.country }}
            </template>
            <template v-slot:token="data">
                <a class="overflow-ellipsis w-64 overflow-hidden block text-blue-800"
                   :href="site_url + '/orders/' + data.value.token">{{ site_url + '/orders/' + data.value.token }}</a>
            </template>
            <template v-slot:articles="data">
               <p class="text-right pr-2">{{ data.value.articles }}</p>
            </template>
            <template v-slot:status="data">
                {{ data.value.status.name }}
            </template>
            <template v-slot:code="data">
                <button v-if="articlesTable" type="button"
                        class="text-sky-900 underline cursor-pointer"
                        @click="edit(data.value)">
                    {{ data.value.code }}
                </button>
                <span v-else>{{ data.value.code }}</span>
            </template>
            <template v-slot:images="data">
                <img class="inline-block rounded-lg mr-1 cursor-pointer" @click="showImage($event)"
                     v-for="image in data.value.images"
                     :src="'/storage/img/articles/' + data.value.id + '/' + image.filename.split('.').slice(0, -1).join('.') + '-thumbnail.' + image.filename.split('.').pop() "
                     :width="50">
            </template>
            <template v-slot:price="data">
                {{ data.value.price }}
            </template>
            <template v-slot:date="data">
                {{ data.value.date }}
            </template>
            <template v-slot:description="data">
<!--                <textarea v-model="articleDescription[data.value.id]" @change="editArticleDescription(data.value.id)" name="description" id="articles-description" rows="1">{{ data.value.description }}</textarea>-->
                <div>
                    <span style="white-space: pre;">{{ data.value.description }}</span>
                </div>
            </template>
            <template v-slot:value="data">
                {{ data.value.value }}
            </template>
            <template v-slot:dismiss="data">
                <button v-if="data.value.status_id < 5 && !data.value.deleted_at" type="button"
                        class="bg-white hover:bg-gray-100 text-gray-800 font-semibold px-4 py-2 border border-gray-400 rounded shadow"
                        @click="$emit('markAs', {data:data, deleteOnly: true})">
                    Apagar
                </button>
            </template>
            <template v-slot:payment_id="data">
                <a v-if="data.value.payment_id"
                   @click="$emit('payment', data.value.payment_id, data.value.payment_table)"
                   class="w-full block text-sky-900 text-center underline cursor-pointer">Ver</a>
            </template>
            <template v-slot:created_at="data">
                {{ data.value.created_at.substring(0, data.value.created_at.indexOf('T')) }}
            </template>
            <template v-slot:pickup_type="data">
                <p v-if="parseInt(data.value.pickup_type, 10) === 1" class="w-full text-right pr-2">Transportadora</p>
                <p v-else-if="parseInt(data.value.pickup_type, 10) === 2" class="w-full text-right pr-2">Em Loja</p>
            </template>
            <template v-slot:total_with_discounts="data">
                <p class="w-full text-right pr-2">{{ data.value.final_total }} €</p>
            </template>
            <template v-slot:validate="data">
                <button type="button"
                        class="bg-white mr-5 hover:bg-gray-100 text-gray-800 font-semibold px-4 py-2 border border-gray-400 rounded s0hadow"
                        @click="$emit('validar', data.value)">
                    Dados
                </button>
            </template>
            <template v-slot:mark_as="data">
                <button v-if="data.value.deleted_at" type="button"
                        class="bg-white w-11/12 hover:bg-gray-100 text-gray-800 font-semibold px-4 py-2 border border-gray-400 rounded shadow"
                        @click="$emit('markAs', {data:data})">
                    <span>Reintroduzir</span>
                </button>
            </template>
            <template v-slot:order_line_sum_qtd="data">
                <button v-if="data.value.order_line_sum_qtd > 0" type="button"
                        class="bg-white w-11/12 hover:bg-gray-100 text-gray-800 font-semibold px-4 py-2 border border-gray-400 rounded shadow"
                        @click="$emit('openUnreserveds', {data:data})">
                    <span>{{ data.value.order_line_sum_qtd }}</span>
                </button>
            </template>
        </table-lite>
    </div>
</template>

<script>
import {
    reactive,
    ref,
    computed
} from 'vue';
import TableLite from "vue3-table-lite";
import {Inertia} from "@inertiajs/inertia";


export default {
    components: {
        TableLite
    },
    mounted() {
        this.table.isReSearch = this.isReSearch ?? this.offset === undefined;
    },
    emits: ['validar', 'checkRows', 'payment', 'goBack', 'doReserve', 'markAs', 'changeStatus', 'openUnreserveds', 'edit'],
    props: ['ordersTable', 'articlesTable', 'rows', 'payment_table', 'payment_id', 'site_url', 'columns', 'total', 'has_checkbox', 'statuses', 'isReSearch', 'page', 'status_list', 'onlyMissingArticles', 'onlyStorePickup', 'onlyPaidArticles'],
    setup(props, {emit}) {

        const currentStatus = decodeURIComponent(window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1));

        const status_list = ref(currentStatus)

        const loaderHidden = ref(true);

        let myKey = ref(0);

        let search = ref("");

        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('search'))
            search.value = urlParams.get('search');

        let image = reactive({
            src: '',
            hidden: true
        });

        function showImage(e) {
            image.src = e.target.src.replace('-thumbnail', '');
            // image.src = e.target.src;
            image.hidden = false;
        }

        function getRows(rows) {
            return computed(() => {
                return rows;
            })

        }

        function getTotal() {
            return props.total;
        }

        const doSearch = (offset, limit, order, sort, fullSearch = true) => {console.log(order,sort)
            table.isLoading = true;
            loaderHidden.value = false;
            table.isReSearch = props.isReSearch ?? offset === undefined;
            // do your search event to get newRows and new Total

            let myData = {
                offset: offset,
                limit: limit,
                order: order,
                sort: sort,
                search: search.value.length > 0 ? search.value : null,
            }

            if (props.onlyMissingArticles)
                myData.onlyMissingArticles = props.onlyMissingArticles.value;

            if (props.onlyStorePickup)
                myData.onlyStorePickup = props.onlyStorePickup.value;

            if (props.onlyPaidArticles)
                myData.onlyPaidArticles = props.onlyPaidArticles.value;

            Inertia.get(window.location.pathname, myData, {
                preserveState: true,
                preserveScroll: true,
                onBefore: function () {
                },
                onSuccess: function (aa) {
                    table.rows = getRows(props.rows);
                    table.totalRecordCount = props.total;
                    loaderHidden.value = true;
                }
            });
            table.sortable.order = order;
            table.sortable.sort = sort;
            tableLoadingFinish(table);
        };

        const tableLoadingFinish = (elements) => {
            table.isLoading = false;
            Array.prototype.forEach.call(elements, function (element) {
                if (element.classList.contains("name-btn")) {
                    element.addEventListener("click", function () {
                        // do your click event
                        console.log(this.dataset.id + " name-btn click!!");
                    });
                }
                if (element.classList.contains("quick-btn")) {
                    // do your click event
                    element.addEventListener("click", function () {
                        console.log(this.dataset.id + " quick-btn click!!");
                    });
                }
            });
        };

        const updateCheckedRows = (rowsKey) => {
            // do your checkbox click event
            emit('checkRows', rowsKey);
        };


        const table = reactive({
            has_checkbox: props.has_checkbox,
            isLoading: false,
            isReSearch: true,
            columns: computed(() => {
                if (props.ordersTable)
                    return props.columns.value.filter(el => el.value)
                return props.columns;
            }),
            rows: getRows(props.rows),
            totalRecordCount: getTotal(),
            sortable: {
                order: "id",
                sort: "desc",
            },
            messages: {
                pagingInfo: "A mostrar {0}-{1} de {2}",
                pageSizeChangeLabel: "Total por página:",
                gotoPageLabel: "Ir para página:",
                noDataAvailable: "Não existem registos",
            },
        });

        const edit = (row) => {
            emit('edit', row)
        }

        const clearSearch = () => {
            search.value = '';
            myKey++;
            doSearch();
        }

        const editArticleDescription = (id) => {
            // TODO: Submit description edition
        }

        let temp = [];
        props.rows.forEach(function (row) {
            temp[row.id] = row.description;
        });

        const articleDescription = ref(temp);



        return {
            showImage,
            image,
            table,
            doSearch,
            search,
            getRows,
            updateCheckedRows,
            tableLoadingFinish,
            myKey,
            loaderHidden,
            status_list,
            edit,
            clearSearch,
            editArticleDescription,
            articleDescription
        }
    }
}
</script>
